interface GoogleConfig {
  API_KEY: string;
  CLIENT_ID: string;
  SECRET: string;
}

interface FacebookConfig {
  APP_ID: string;
}

interface HereMapsConfig {
  API_KEY: string;
  APP_ID: string;
}

interface ApiConfig {
  API_URL: string;
  AUTH_API_URL: string;
}

interface Config {
  google: GoogleConfig;
  facebook: FacebookConfig;
  hereMaps: HereMapsConfig;
  api: ApiConfig;
  pagination: {
    DEFAULT_PAGE_SIZE: number;
  };
}

const config: Config = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  hereMaps: {
    // Vite uses import.meta.env instead of process.env
    // Support both VITE_ prefix (Vite) and REACT_APP_ prefix (for backward compatibility)
    API_KEY: import.meta.env.VITE_HERE_API_KEY || import.meta.env.REACT_APP_HERE_API_KEY || "",
    APP_ID: import.meta.env.VITE_HERE_APP_ID || import.meta.env.REACT_APP_HERE_APP_ID || "",
  },
  api: {
    // API base URL is selected at build time via VITE_API_URL, set per
    // environment in the .env.[mode] files:
    //   DEV  (.env.development) → npm run build      → app-fieldtrix-api-dev
    //   PROD (.env.production)  → npm run build:prod → app-euro-scaffolds-api-prod
    // The hardcoded value below is only a fallback (dev) if no env var is set.
    API_URL:
      import.meta.env.VITE_API_URL ||
      "https://app-fieldtrix-api-dev.azurewebsites.net/api/v1",
    AUTH_API_URL:
      import.meta.env.VITE_AUTH_API_URL ||
      import.meta.env.VITE_API_URL ||
      "https://app-fieldtrix-api-dev.azurewebsites.net/api/v1",
  },
  pagination: {
    DEFAULT_PAGE_SIZE: parseInt(
      import.meta.env.VITE_DEFAULT_PAGE_SIZE ||
      import.meta.env.REACT_APP_DEFAULT_PAGE_SIZE ||
      "200",
      10
    ),
  },
};

export default config;
